"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Icon = void 0;
const react_1 = __importDefault(require("react"));
const _1 = require(".");
const IconsPaths = __importStar(require("./Icon.paths"));
const Icon = ({ size = _1.IconSize.Medium, color = _1.IconColor.DigitalBlack, name = _1.IconName.CarlsbergFilled, viewBox, className, onClick }) => {
    const IconElement = IconsPaths[name];
    return (react_1.default.createElement(IconElement, { viewBox: viewBox !== null && viewBox !== void 0 ? viewBox : '0 0 24 24', className: className, color: color, size: size, onClick: onClick }));
};
exports.Icon = Icon;
//# sourceMappingURL=Icon.js.map